import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Award, Clock, ArrowRight } from "lucide-react";

export const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/a7a9bpq5_IMG_1428.jpeg"
          alt="G.P.C Caulking Specialist at work"
          className="w-full h-full object-contain object-center bg-[#0F172A]"
        />
        <div className="absolute inset-0 hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8 animate-fade-in">
            <Award className="w-4 h-4 text-[#F59E0B]" />
            <span className="text-white text-sm font-medium">Gold Coast's Trusted Commercial Caulking Specialists</span>
          </div>

          {/* Headline */}
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6 animate-slide-up">
            Professional Caulking
            <span className="text-[#F59E0B] block">From Start to Finish</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg text-slate-300 leading-relaxed mb-8 max-w-2xl animate-slide-up stagger-1">
            Specialising in commercial builds across the Gold Coast. Expert polyurethane blockwork, 
            render expansion joints, fire-rated caulking with certification, and complete internal silicone works.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 animate-slide-up stagger-2">
            <Link to="/quote">
              <Button
                size="lg"
                className="bg-[#F59E0B] hover:bg-[#D97706] text-[#0F172A] font-heading font-bold uppercase tracking-wide px-8 py-6 text-lg btn-pulse"
                data-testid="hero-get-quote-btn"
              >
                Get a Free Quote
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/services">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#0F172A] font-heading font-bold uppercase tracking-wide px-8 py-6 text-lg bg-transparent"
                data-testid="hero-services-btn"
              >
                Our Services
              </Button>
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 animate-slide-up stagger-3">
            <div className="trust-badge rounded-lg p-4 flex items-center gap-3">
              <div className="w-12 h-12 bg-[#F59E0B]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <ShieldCheck className="w-6 h-6 text-[#F59E0B]" />
              </div>
              <div>
                <p className="text-white font-medium">Fire Rated</p>
                <p className="text-slate-400 text-sm">Certified & Compliant</p>
              </div>
            </div>
            <div className="trust-badge rounded-lg p-4 flex items-center gap-3">
              <div className="w-12 h-12 bg-[#F59E0B]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Award className="w-6 h-6 text-[#F59E0B]" />
              </div>
              <div>
                <p className="text-white font-medium">15+ Years</p>
                <p className="text-slate-400 text-sm">Industry Experience</p>
              </div>
            </div>
            <div className="trust-badge rounded-lg p-4 flex items-center gap-3">
              <div className="w-12 h-12 bg-[#F59E0B]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Clock className="w-6 h-6 text-[#F59E0B]" />
              </div>
              <div>
                <p className="text-white font-medium">On-Time</p>
                <p className="text-slate-400 text-sm">Delivery Guaranteed</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden lg:block">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
